var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('iframe',{attrs:{"src":_vm.url,"width":"100%","height":"100%","frameborder":"0"}}):_c('v-layout',{staticStyle:{"background-color":"var(--primary-normal)"},attrs:{"fill-height":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"warning-message"},[_vm._v("\n    Service not available\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae6b9814","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Support/Manuals/Wiki.vue
// module id = null
// module chunks = 